// src/lib/apiClient.js
import { createApiClient } from '@astra/core/api';
import { supabase } from './supabaseClient';
import { buildUsageHeaders } from './aiUsage';

export const { fetchWithAuth } = createApiClient({
  supabase,
  getDefaultHeaders: () => buildUsageHeaders(),
});

export default fetchWithAuth;
